export const env = {
  appUrl: (import.meta.env.VITE_APP_URL as string | undefined) ?? 'http://localhost:5173',
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined,
  gitHash: import.meta.env.VITE_GIT_HASH as string | undefined,
  appVersion: import.meta.env.VITE_APP_VERSION as string | undefined,
}
